import React, { Fragment } from "react"
import { zoomIn } from "react-animations"
import Radium, { StyleRoot } from "radium"
import { LazyLoadImage } from "react-lazy-load-image-component"

const styles = {
  zoomIn: {
    animation: "x 0.5s",
    animationName: Radium.keyframes(zoomIn, "zoomIn"),
  },
}

const PortfolioTemplate = props => {
  const { filtered } = props

  return (
    <Fragment>
      <StyleRoot>
        <div className="row">
          {filtered.map(item => (
            <div
              className="col-lg-4 col-md-6 portfolio-item filter-buisness wow "
              key={item.id}
            >
              <div className="portfolio-wrap " style={styles.zoomIn}>
                <figure className="m-0">
                  <LazyLoadImage
                    className="portfolio-size"
                    style={{
                      background: `url(${item.Image.url})`,
                    }}
                  />
                  <a
                    href={item.Website_URL}
                    target="_blank"
                    className="link-preview"
                  >
                    <i className="fa fa-eye" />
                  </a>
                  <a
                    href={item.Website_URL}
                    target="_blank"
                    className="link-details"
                  >
                    <i className="fa fa-external-link" />
                  </a>
                </figure>
                <div className="portfolio-info">
                  <h4>
                    <a href={item.Website_URL} target="_blank">
                      {item.Company_Name}
                    </a>
                  </h4>
                  <p>
                    <a href={item.Website_URL} target="_blank">
                      {item.Website_URL}
                    </a>
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </StyleRoot>
    </Fragment>
  )
}

export default PortfolioTemplate
